export const Plugins: E5Plugins = {} as any;